import {TranslationKeyProps} from 'shared/util/translated-props';
import {TextSectionProps} from '../components/text-section';

export const getTextSection =
  <T>(
    data: Omit<TextSectionProps<T>, 'type' | 'translationKey'> & {
      translationKey?: TranslationKeyProps;
    },
  ) =>
  (): TextSectionProps<T> => ({
    ...data,
    translationKey: data.translationKey!,
    type: 'text-section',
  });
